// src/pages/SignUp.jsx
import React, { useState } from "react";
import { Button, Form, Input, Card, Typography, message } from "antd";
import { useAuth } from "../context/AuthContext";
import { useLocation } from "wouter";

const { Title, Text } = Typography;

const SignUp = () => {
  const { signup } = useAuth();
  const [, setLocation] = useLocation();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    const { email, password } = values;
    setLoading(true);
    try {
      await signup(email, password);
      message.success("Inscription réussie ! Bienvenue sur BioConnect");
      setTimeout(() => {
        setLocation("/");
      }, 500);
    } catch (err) {
      console.error("Erreur d'inscription:", err);
      if (err.code === "auth/email-already-in-use") {
        message.error("Cet email est déjà utilisé");
      } else if (err.code === "auth/weak-password") {
        message.error("Le mot de passe doit contenir au moins 6 caractères");
      } else {
        message.error("Erreur lors de l'inscription");
      }
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    // Validation failed
  };

  return (
    <div className="auth-page-container">
      <Card
        className="auth-card"
        classNames={{ header: "auth-card-header", body: "auth-card-body" }}
      >
        <div className="auth-title-wrapper">
          <Title level={2} style={{ color: "var(--brand-primary)", marginBottom: 8 }}>
            <span className="brand-bio">Bio</span>
            <span className="brand-connect">Connect</span>
          </Title>
          <Text className="auth-subtitle">Créez votre compte</Text>
        </div>

        <Form
          form={form}
          layout="vertical"
          name="signup"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label={<span className="form-label-light">Email</span>}
            name="email"
            rules={[
              { required: true, message: "Veuillez saisir votre email !" },
              { type: "email", message: "Email invalide !" }
            ]}
          >
            <Input
              size="large"
              placeholder="votre@email.com"
              className="input-dark"
            />
          </Form.Item>

          <Form.Item
            label={<span className="form-label-light">Mot de passe</span>}
            name="password"
            rules={[
              { required: true, message: "Veuillez saisir un mot de passe !" },
              { min: 6, message: "Minimum 6 caractères" }
            ]}
          >
            <Input.Password
              size="large"
              placeholder="••••••••"
              className="input-dark"
            />
          </Form.Item>

          <Form.Item
            label={<span className="form-label-light">Confirmer le mot de passe</span>}
            name="confirmPassword"
            dependencies={['password']}
            hasFeedback
            rules={[
              { required: true, message: 'Veuillez confirmer votre mot de passe !' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Les mots de passe ne correspondent pas !'));
                },
              }),
            ]}
          >
            <Input.Password
              size="large"
              placeholder="••••••••"
              className="input-dark"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              block
              className="btn-submit-primary"
            >
              S'inscrire
            </Button>
          </Form.Item>
        </Form>

        <div className="auth-link-area">
          <Text className="text-dark">Déjà un compte ? </Text>
          <Button
            type="link"
            onClick={() => setLocation("/signin")}
            className="btn-link-brand"
          >
            Se connecter
          </Button>
        </div>

        <div className="auth-footer-divider">
          <Text className="text-small-secondary">
            En vous inscrivant, vous acceptez nos conditions d'utilisation et notre politique de confidentialité.
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default SignUp;
